var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4 4.72563 3.44797 5.25 2.85 5.25C2.25203 5.25 1.7 4.72563 1.7 4C1.7 3.27437 2.25203 2.75 2.85 2.75C3.44797 2.75 4 3.27437 4 4ZM17.3 4C17.3 4.72563 16.748 5.25 16.15 5.25C15.552 5.25 15 4.72563 15 4C15 3.27437 15.552 2.75 16.15 2.75C16.748 2.75 17.3 3.27437 17.3 4ZM16.7127 10.25C16.4715 9.28248 15.9773 8.42256 15.303 7.75H17.1C17.698 7.75 18.25 8.27437 18.25 9V10C18.25 10.1756 18.1255 10.25 18.05 10.25H16.7127ZM12.075 3.5C12.075 5.05688 10.8877 6.25 9.5 6.25C8.11234 6.25 6.925 5.05688 6.925 3.5C6.925 1.94312 8.11234 0.75 9.5 0.75C10.8877 0.75 12.075 1.94312 12.075 3.5ZM9.5 9.25C10.2948 9.25 11.0382 9.06137 11.706 8.75H11.78C13.2181 8.75 14.45 9.99 14.45 11.6V12.5C14.45 12.9506 14.1117 13.25 13.775 13.25H5.225C4.88828 13.25 4.55 12.9506 4.55 12.5V11.6C4.55 9.99 5.78187 8.75 7.22 8.75H7.2946C7.96335 9.06089 8.70423 9.25 9.5 9.25ZM3.69697 7.75C3.02237 8.42267 2.52788 9.28265 2.28537 10.25H0.95C0.87453 10.25 0.75 10.1756 0.75 10V9C0.75 8.27437 1.30203 7.75 1.9 7.75H3.69697Z",
    stroke: "CurrentColor",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.5c810ea95eff868512b3aa71fd7fef0c.svg";
export { ForwardRef as ReactComponent };